import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React, { FormEvent, useCallback, useState } from 'react';
import PinField from 'react-pin-field';
import ksimMachinist from '../assets/ksim-captain.png';

export interface VerifyDialogProps {
  errorMessage?: string;
  loading: boolean;
  message: string;
  onClose: () => void;
  onConfirm: (code: string) => boolean;
  open: boolean;
  submitLabel?: string;
}

const VerifyDialog = ({
  errorMessage,
  loading,
  message,
  onClose,
  onConfirm,
  open,
  submitLabel = 'Submit',
}: VerifyDialogProps) => {
  const pinRef = useCallback((inputElements: HTMLInputElement[]) => {
    if (inputElements) {
      errorMessage = undefined;
      inputElements[0].focus();
    }
  }, []);
  const [pin, setPin] = useState<string>();

  const onPinChange = (pin: string) => {
    setPin(pin);
  };

  const onVerify = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onConfirm(pin!);
  };

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      onClose={onClose}
      sx={{ textAlign: 'center' }}
      PaperProps={{ sx: { borderRadius: 4 } }}
    >
      <form onSubmit={onVerify}>
        <DialogTitle sx={{ py: 4 }}>{message}</DialogTitle>
        <DialogContent>
          <Box component="img" src={ksimMachinist} />
          <Box display="flex" gap={2} justifyContent="center">
            <Box
              component={PinField}
              disabled={loading}
              onChange={onPinChange}
              length={4}
              ref={pinRef}
              sx={theme => ({
                background: 'transparent',
                border: 'none',
                borderBottom: `2px solid ${theme.palette.text.disabled}`,
                color: errorMessage && 'error.main',
                fontWeight: 700,
                fontSize: 48,
                width: 32,
                textAlign: 'center',
                '&:focus': {
                  outline: 'none',
                },
              })}
              validate={/^\d*$/}
            />
          </Box>
          {errorMessage && (
            <Typography color="error.main" mt={3}>
              {errorMessage}
            </Typography>
          )}
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center', pb: 4 }}>
          <Button variant="outlined" onClick={onClose}>
            Cancel
          </Button>
          <Button disabled={!pin || +pin.length < 4 || loading} type="submit" variant="contained">
            {submitLabel}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default VerifyDialog;
